import { HandleStatusCode } from "../common/FetchHelpers";
import { GetReqConfig } from "../common/authHeaders";

const templateUrl = "api/templates";

const RequestTemplateService = {

    GetOba: () => {
        const url = templateUrl + "/oba";
        return fetch(url, GetReqConfig())
            .then((res) => HandleStatusCode(res))
            .then(async(response) => {
                if (response.status === 204) {
                    return "";
                }
                return await response.json();
            });
    },
    GetPreTrade: () => {
        const url = templateUrl + "/pretrade";
        return fetch(url, GetReqConfig())
            .then((res) => HandleStatusCode(res))
            .then(async(response) => {
                if (response.status === 204) {
                    return "";
                }
                return await response.json();
            });
    }

};

export default RequestTemplateService;